import React, {useState} from 'react';

interface AnalyticsData {
    nutrition_itog: number;
    trainings_itog: number;
    vitamins_itog: number;
    labels: string[];
    nutrition_data: number[];
    trainings_data: number[];
    vitamins_data: number[];
}

interface ResultsPageProps {
    month: string;
    analyticsData: AnalyticsData;
}

export const ResultsPage: React.FC<ResultsPageProps> = ({ month, analyticsData }) => {
    const [modalOpen, setModalOpen] = useState(true); // true для демонстрации, потом false
    const colors = {
        nutrition: 'medium',
        trainings: 'high',
        vitamins: 'very-high',
    };

    const labels = {
        nutrition: 'питанию',
        trainings: 'тренировкам',
        vitamins: 'витаминам',
    };

    const metrics: Array<keyof typeof labels> = ['nutrition', 'trainings', 'vitamins'];

    return (
        <>
            {modalOpen && (
                <div className="modalV A">
                    <div className="modal__contentV">
                        <h2>
                            <strong style={{display: 'flex', fontSize: '20px'}}><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 22.5C5.45 22.5 4.97933 22.3043 4.588 21.913C4.19667 21.5217 4.00067 21.0507 4 20.5V10.5C4 9.95 4.196 9.47933 4.588 9.088C4.98 8.69667 5.45067 8.50067 6 8.5H7V6.5C7 5.11667 7.48767 3.93767 8.463 2.963C9.43833 1.98833 10.6173 1.50067 12 1.5C13.3827 1.49933 14.562 1.987 15.538 2.963C16.514 3.939 17.0013 5.118 17 6.5V8.5H18C18.55 8.5 19.021 8.696 19.413 9.088C19.805 9.48 20.0007 9.95067 20 10.5V20.5C20 21.05 19.8043 21.521 19.413 21.913C19.0217 22.305 18.5507 22.5007 18 22.5H6ZM12 17.5C12.55 17.5 13.021 17.3043 13.413 16.913C13.805 16.5217 14.0007 16.0507 14 15.5C13.9993 14.9493 13.8037 14.4787 13.413 14.088C13.0223 13.6973 12.5513 13.5013 12 13.5C11.4487 13.4987 10.978 13.6947 10.588 14.088C10.198 14.4813 10.002 14.952 10 15.5C9.998 16.048 10.194 16.519 10.588 16.913C10.982 17.307 11.4527 17.5027 12 17.5ZM9 8.5H15V6.5C15 5.66667 14.7083 4.95833 14.125 4.375C13.5417 3.79167 12.8333 3.5 12 3.5C11.1667 3.5 10.4583 3.79167 9.875 4.375C9.29167 4.95833 9 5.66667 9 6.5V8.5Z" fill="black"/>
                            </svg>
                                Доступ временно ограничен</strong>
                        </h2>
                    </div>
                </div>
            )}
            <main className={`layout__content ${modalOpen ? 'blurred' : ''}`}>

                <section className={`section layout__section program vitamins ${modalOpen ? 'blurred' : ''}`}>
                    <div className="container">
                        <header className="section__header program__header program-header">
                            {/* Навигация — при необходимости вставить */}
                            <div className="program-header__top program-header-top program-header-top_no-margin">
                                <div className="program-header-top__inner">
                                    <div className="program-header-top__left">
                                        <h1 className="title section__title">Результаты</h1>
                                        <div className="program__time">
                                            <div className="program__time-badge">за {month} месяц</div>
                                        </div>
                                        <span className="program__label">Вы молодец, но можете лучше!</span>
                                    </div>
                                    <div className="program-header-top__right">
                                        {/* Профиль/подписка */}
                                    </div>
                                </div>
                            </div>
                            <div className="program-header__bottom program-header-bottom">
                                <div className="program-header-bottom__inner">
                                    <div className="program-header-bottom__left">
                                        <p className="program__note">
                                            И есть, над чем поработать. Посмотрите диаграммы — это аналитика ваших успехов.
                                        </p>
                                    </div>
                                    <div className="program-header-bottom__right">
                                        <p className="program__description">
                                            Важно соблюдать баланс и заботиться обо всех аспектах здоровья...
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </header>

                        <div className="section__content">
                            <div className="results__data results-data">
                                <div className="results-data__grid">
                                    {metrics.map((metric) => (
                                        <div key={metric} className="results-data__col">
                                            <div className="results-data__item results-data-item">
                                                <div className="results-data-item__chart">
                                                    <div className="pie-chart">
                                                        <div
                                                            className="pie-chart__inner"
                                                            style={{
                                                                ['--color' as any]: `var(--health-level-color-${colors[metric]})`,
                                                                ['--progress' as any]: `${analyticsData[`${metric}_itog` as keyof AnalyticsData]}%`,
                                                            }}
                                                        >
                                                            <div className="pie-chart__value">
                                                                {analyticsData[`${metric}_itog` as keyof AnalyticsData]}%
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="results-data-item__info">
                                                <span className="results-data-item__label">
                                                    Выполнение плана по {labels[metric]}
                                                </span>
                                                    <span className="results-data-item__period">за месяц</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {metrics.map((metric) => (
                                        <div key={`${metric}-chart`} className="results-data__col">
                                            <div className="results-data__item results-data-item">
                                                <div className="results-data-item__chart">
                                                    {/* Вставить Chart.js или другой график здесь */}
                                                </div>
                                                <div className="results-data-item__info">
                                                <span className="results-data-item__label">
                                                    Выполнение плана по {labels[metric]}
                                                </span>
                                                    <span className="results-data-item__period">по дням</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="section layout__section next-program">
                    <div className="container">
                        <div className="next-program__inner">
                            <img
                                className="next-program__image"
                                src="/img/intro-test-image.png"
                                alt="Лимоны в руке"
                            />
                            <div className="next-program__info">
                                <div className="next-program__title">
                                    <h2>Новая программа от <strong>BionMax</strong></h2>
                                    <span className="next-program__badge">на следующий месяц</span>
                                </div>
                                <div className="next-program__card">
                                    <p className="next-program__text">
                                        Пройдите тест на оценку улучшения самочувствия и ваших достижений и получите программу по
                                        тренировкам, питанию и витаминам на новый месяц.
                                    </p>
                                    <div className="next-program__action">
                                        <a className="button button_outline" href="/online-check/passing-a-retest">
                                            Пройти тест
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};
